/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';

class ScoreIndicator extends React.Component {

    render() {
        const NUMBER_OF_STARS = 5;
        const HALF_LOWER_BOUND = 0.25;
        const HALF_UPPER_BOUND = 0.75;

        const mScore = Math.max(0, Math.min(this.props.score, 100));

        const scoreNormalized = mScore / (100.0 / 5);
        const floor = Math.floor(scoreNormalized);
        const floating = scoreNormalized - floor;


        const fullStarCount = (floor + (floating >= HALF_UPPER_BOUND ? 1 : 0));
        let partialStarCount = 0;
        if (floating >= HALF_LOWER_BOUND && floating < HALF_UPPER_BOUND) {
            partialStarCount = 1;
        }

        const textClass = (this.props.textClass || 'text-warning') + " small";
        const faFullClass = this.props.fullClass || 'fas fa-star';
        const faHalfClass = this.props.halfClass || 'fas fa-star-half-alt';
        const faEmptyClass = this.props.emptyClass || 'far fa-star';

        let starClasses = [];
        for (let i = 0; i < fullStarCount; i++) {
            starClasses.push(faFullClass + " fa-fw");
        }
        for (let i = fullStarCount; i < fullStarCount + partialStarCount; i++) {
            starClasses.push(faHalfClass + " fa-fw");
        }
        for (let i = fullStarCount + partialStarCount; i < NUMBER_OF_STARS; i++) {
            starClasses.push(faEmptyClass + " fa-fw");
        }

        return (
            <span className={textClass}>
                {starClasses.map((starFaClass, index) =>
                    <span key={index} className={starFaClass}/>
                )}
            </span>
        );
    }
}

export default ScoreIndicator;